"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrlType = void 0;
var UrlType;
exports.UrlType = UrlType;

(function (UrlType) {
  UrlType["LAYOUT"] = "LAYOUT";
  UrlType["EXTERNAL"] = "EXTERNAL";
  UrlType["INTERNAL"] = "INTERNAL";
  UrlType["WEB_VIEW"] = "WEB_VIEW";
  UrlType["TAG_INFO"] = "TAG_INFO";
  UrlType["LIVE_STREAM"] = "LIVE_STREAM";
  UrlType["EVENT_STREAM"] = "EVENT_STREAM";
  UrlType["DEEP_LINK"] = "DEEP_LINK";
  UrlType["LOGO"] = "LOGO";
  UrlType["ICON"] = "ICON";
  UrlType["EMAIL"] = "EMAIL";
})(UrlType || (exports.UrlType = UrlType = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2VudW1zL1VybFR5cGUudHMiXSwibmFtZXMiOlsiVXJsVHlwZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0lBQVlBLE87OztXQUFBQSxPO0FBQUFBLEVBQUFBLE87QUFBQUEsRUFBQUEsTztBQUFBQSxFQUFBQSxPO0FBQUFBLEVBQUFBLE87QUFBQUEsRUFBQUEsTztBQUFBQSxFQUFBQSxPO0FBQUFBLEVBQUFBLE87QUFBQUEsRUFBQUEsTztBQUFBQSxFQUFBQSxPO0FBQUFBLEVBQUFBLE87QUFBQUEsRUFBQUEsTztHQUFBQSxPLHVCQUFBQSxPIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gVXJsVHlwZSB7XG4gICAgTEFZT1VUID0gJ0xBWU9VVCcsXG4gICAgRVhURVJOQUwgPSAnRVhURVJOQUwnLFxuICAgIElOVEVSTkFMID0gJ0lOVEVSTkFMJyxcbiAgICBXRUJfVklFVyA9ICdXRUJfVklFVycsXG4gICAgVEFHX0lORk8gPSAnVEFHX0lORk8nLFxuICAgIExJVkVfU1RSRUFNID0gJ0xJVkVfU1RSRUFNJyxcbiAgICBFVkVOVF9TVFJFQU0gPSAnRVZFTlRfU1RSRUFNJyxcbiAgICBERUVQX0xJTksgPSAnREVFUF9MSU5LJyxcbiAgICBMT0dPID0gJ0xPR08nLFxuICAgIElDT04gPSAnSUNPTicsXG4gICAgRU1BSUwgPSAnRU1BSUwnLFxufVxuIl19